module.exports = __webpack_public_path__ + "img/KinokoTable49.9d985488.jpg";